/**
 * Minimum password length enforced when registering a driver account.
 *
 * No backend minimum-length policy was available to mirror for this change
 * (the backend repo was out of scope for this task), so 8 characters is
 * used as a reasonable default. See task-3-report.md for details.
 */
export const MIN_DRIVER_PASSWORD_LENGTH = 8;

export function isValidDriverPassword(password: string): boolean {
  return password.length >= MIN_DRIVER_PASSWORD_LENGTH;
}
